import { render, staticRenderFns } from "./BlockUserDialog.vue?vue&type=template&id=5f0aaf74&"
import script from "./BlockUserDialog.vue?vue&type=script&lang=js&"
export * from "./BlockUserDialog.vue?vue&type=script&lang=js&"
import style0 from "./BlockUserDialog.vue?vue&type=style&index=0&id=5f0aaf74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports